import React, { useState, useEffect } from 'react';

const LoadingEllipsis = () => {
    const [dots, setDots] = useState('');

    useEffect(() => {
        const intervalId = setInterval(() => setDots(e => e.length > 2 ? '' : e + '.'), 300);
        return () => clearInterval(intervalId);
    }, []);

    return <>{dots}</>;
};

export default LoadingEllipsis;